import httpClient from '../httpClient';

const info = async (id) => {
  return await httpClient.get(`/modification_product/${id}/info/`);
};

const post = async (data) => {
  return await httpClient.post('/modification_product/', data);
};

const patch = async (id, data) => {
  return await httpClient.patch(`/modification_product/${id}/`, data);
};

const remove = async (id) => {
  return await httpClient.delete(`/modification_product/${id}/`);
};

const renumerate = async (modificacion_id) => {
  return await httpClient.post('/modification_product/renumerate/', {
    mm: modificacion_id,
  });
};
const swap = async (a, b) => {
  return await httpClient.post('/modification_product/swap/', {
    a: a,
    b: b,
  });
};

const move = async (id, data) => {
  return await httpClient.patch(`/modification_product/${id}/move/`, data);
};

const duplicate = async (id, values) => {
  return await httpClient.patch(
    `modification_product/${id}/duplicate/`,
    values,
  );
};

const view_home = async (query, page = 1, pageSize = 10, search = false) => {
  return await httpClient.get(
    `/modification_product/view_home/?page[number]=${page}&page[size]=${pageSize}&filter[modulo_modificacion]=${query}${
      search ? `&filter[search]=${search}` : ''
    }`,
  );
};

const filter = async (
  query,
  page = 1,
  pageSize = 10,
  _sortBy = '-created_at',
  search = false,
  exportCSV = false,
) => {
  if (exportCSV)
    return await httpClient.get(
      `/modification_product/export/?filter[modulo_modificacion]=${query}${
        search ? `&filter[search]=${search}` : ''
      }`,
      {
        responseType: 'blob',
      },
    );
  else
    return await httpClient.get(
      `/modification_product/?page[number]=${page}&page[size]=${pageSize}&filter[modulo_modificacion]=${query}${
        search ? `&filter[search]=${search}` : ''
      }`,
    );
};

const get = async (id) => await httpClient.get(`/modification_product/${id}/`);

const preview = async (
  query,
  page = 1,
  pageSize = 10,
  _sortBy = '-created_at',
  search = false,
  exportCSV = false,
) => {
  if (exportCSV)
    return await httpClient.get(
      `/modification_product/export_preview/?filter[modulo_modificacion]=${query}${
        search ? `&filter[search]=${search}` : ''
      }`,
      {
        responseType: 'blob',
      },
    );
  else
    return await httpClient.get(
      `/modification_product/preview/?page[number]=${page}&page[size]=${pageSize}&filter[modulo_modificacion]=${query}${
        search ? `&filter[search]=${search}` : ''
      }`,
    );
};

const patchModule = async (id, data) => {
  return await httpClient.patch(
    `/modification_product/${id}/update_module/`,
    data,
  );
};

const getPAInfo = async (contractID) =>
  await httpClient.get(`/modification_pa/${contractID}/info/`);

const previewPA = async (
  query,
  page = 1,
  pageSize = 10,
  _sortBy = '-created_at',
  search = false,
  _exportCSV = false,
) =>
  await httpClient.get(`/modification_pa/`, {
    params: {
      'page[number]': page,
      'page[size]': pageSize,
      'filter[contrato]': query,
      'filter[search]': search ? search : null,
    },
  });

const getPAPayProducts = async (payID) =>
  httpClient.get(`/modification_pa/${payID}/`);

const getPAUnits = async (id, product_id) =>
  await httpClient.get(`modification_pa/${id}/get_units/`, {
    params: { 'filter[producto]': product_id },
  });

export {
  info,
  post,
  patch,
  remove,
  filter,
  get,
  swap,
  preview,
  view_home,
  patchModule,
  getPAInfo,
  previewPA,
  getPAPayProducts,
  getPAUnits,
  renumerate,
  move,
  duplicate,
};
